import * as React from "react"
import { Row } from "react-grid-system"
import styled from "styled-components"
import H4 from "../../../atoms/typography/H4"
import { Spacer } from "../../../atoms/spacers"
import H3 from "../../../atoms/typography/H3"
import { ArrowDropUpIcon } from "../../../atoms/icons/ArrowDropUpIcon"
import { ArrowDropDownIcon } from "../../../atoms/icons/ArrowDropDownIcon"
import { MediaQuery } from "../../../../utils/design-helpers"
import Body from "../../../atoms/typography/Body"

interface Props {
  step: number
  title: string
  open: boolean
  onClick: () => void
  disabled?: boolean
}

const NumberContainer = styled.div<{ open: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: ${(props) => (props.open ? props.theme.colors.greyDark : props.theme.colors.greyDisabled)};
`

const TitleSection = styled.div`
  display: flex;
  align-items: center;
`

const TopRow = styled(Row)<{ disabled?: boolean }>`
  cursor: ${(props) => (props.disabled ? undefined : "pointer")};
`

const PaddedRow = styled.div`
  padding: 16px;

  ${MediaQuery.XS} {
    padding: 8px;
  }
`

const CustomizeTitle: React.FC<Props> = ({ step, title, open, onClick, disabled }) => {
  return (
    <PaddedRow>
      <TopRow justify="between" align="center" nogutter onClick={disabled ? undefined : onClick} disabled={disabled}>
        <TitleSection>
          <NumberContainer open={open}>
            <H4 color="white" textAlign="center">
              {step}
            </H4>
          </NumberContainer>
          <Spacer spacing={1} />

          <H3>{title}</H3>
        </TitleSection>

        <div>{open ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}</div>
      </TopRow>
    </PaddedRow>
  )
}

export default CustomizeTitle
